<template>
  <div class="wp-page">
    <div class="wp-card">
      <div class="wp-header">
        <div class="wp-title">工单池</div>
        <div class="wp-divider"></div>
        <div class="wp-toolbar sheet-filter-tabs">
          <div class="wp-actions sheet-tabs">
            <button v-for="item in states" :key="item.statusCd" type="button" :class="['sheet-tab', conditions.state === item.statusCd ? 'is-active' : '']" @click="switchState(item)">{{ item.name }}</button>
            <el-button size="small" class="wp-btn-refresh" title="刷新" @click="handleRefresh"><i class="el-icon-refresh"></i></el-button>
          </div>
        </div>
        <div class="wp-search-sheet">
          <div class="wp-search-group">
            <el-input v-model="conditions.workNo" size="small" clearable placeholder="工单编号" class="wp-search-input small" />
            <el-input v-model="conditions.location" size="small" clearable placeholder="告警位置" class="wp-search-input small" />
            <el-select v-model="conditions.alarmType" size="small" clearable filterable placeholder="请选择告警类型" class="wp-search-select" :loading="alarmTypeLoading">
              <el-option v-for="item in alarmTypes" :key="item.alarmTypeCd" :label="item.alarmTypeName" :value="item.alarmTypeCd" />
            </el-select>
            <el-input v-model="conditions.handler" size="small" clearable placeholder="处理人" class="wp-search-input small" />
            <div class="wp-date-range">
              <el-date-picker v-model="conditions.startTime" size="small" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="wp-date" />
              <span class="date-range-separator"></span>
              <el-date-picker v-model="conditions.endTime" size="small" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="wp-date" />
            </div>
            <el-button size="small" class="wp-btn-search" @click="handleSearch"><i class="el-icon-search"></i>搜索</el-button>
          </div>
        </div>
      </div>

      <div class="wp-table-section">
        <el-table v-loading="loading" :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="communityName" label="所在小区" min-width="150" show-overflow-tooltip />
          <el-table-column prop="workNo" label="工单编号" min-width="180" show-overflow-tooltip />
          <el-table-column prop="alarmType" label="告警类型" min-width="130" show-overflow-tooltip />
          <el-table-column prop="deviceInfo" label="设备信息" min-width="150" show-overflow-tooltip />
          <el-table-column prop="location" label="联系位置" min-width="150" show-overflow-tooltip />
          <el-table-column prop="alarmName" label="告警名称" min-width="150" show-overflow-tooltip />
          <el-table-column prop="handler" label="处理人员" min-width="120" show-overflow-tooltip />
          <el-table-column prop="alarmTime" label="告警时间" min-width="180" show-overflow-tooltip />
          <el-table-column prop="createTime" label="创建时间" min-width="180" show-overflow-tooltip />
          <el-table-column prop="finishTime" label="完成时间" min-width="180" show-overflow-tooltip />
          <el-table-column label="状态" min-width="120">
            <template slot-scope="scope">
              <span :class="['status-tag', statusClass(scope.row.state)]">{{ scope.row.stateName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="160" fixed="right">
            <template slot-scope="scope">
              <span class="action-links">
                <a class="action-link" @click="handleView(scope.row)">详情</a>
                <span v-if="scope.row.state === '1500'" class="link-separator"></span>
                <a v-if="scope.row.state === '1500'" class="action-link" @click="handleFinish(scope.row)">处理完成</a>
                <span v-if="!['1900', '2000'].includes(scope.row.state)" class="link-separator"></span>
                <a v-if="!['1900', '2000'].includes(scope.row.state)" class="action-link danger" @click="handleClose(scope.row)">结束</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="wp-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.row"
          :page-sizes="[10, 20, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          :hide-on-single-page="false"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange" />
      </div>
    </div>

    <end-work-order ref="endWorkOrder" @success="handleRefresh" />
  </div>
</template>

<script>
import { listInspectionWorks, completeInspectionWork } from '@/api/inspection/workPoolApi'
import { listAlarmTypeMappings } from '@/api/inspection/alarmTypeMappingApi'
import EndWorkOrder from '@/components/work/endWorkOrder'

export default {
  name: 'WorkPoolList',
  components: { EndWorkOrder },
  data() {
    return {
      loading: false,
      alarmTypeLoading: false,
      states: [
        { statusCd: '', name: '全部' },
        { statusCd: 'TIMEOUT', name: '超时工单' },
        { statusCd: '1000', name: '待处理' },
        { statusCd: '1900', name: '办理完成' },
        { statusCd: '2000', name: '结束' }
      ],
      alarmTypes: [],
      conditions: {
        workNo: '',
        location: '',
        alarmType: '',
        handler: '',
        state: '',
        startTime: '',
        endTime: ''
      },
      tableData: [],
      pagination: { page: 1, row: 10, total: 0 }
    }
  },
  mounted() {
    this.fetchList()
    this.loadAlarmTypeOptions()
  },
  methods: {
    async loadAlarmTypeOptions() {
      this.alarmTypeLoading = true
      try {
        const res = await listAlarmTypeMappings({ page: 1, row: 100, statusCd: '0' })
        const list = res.list || []
        // 同一告警类型可能对应多个消息来源，按告警类型名称去重
        const uniqueMap = new Map()
        list.forEach(item => {
          if (item.alarmTypeName && !uniqueMap.has(item.alarmTypeName)) {
            uniqueMap.set(item.alarmTypeName, item)
          }
        })
        this.alarmTypes = Array.from(uniqueMap.values())
      } catch (error) {
        this.$message.error(error.message || '获取告警类型列表失败')
        this.alarmTypes = []
      } finally {
        this.alarmTypeLoading = false
      }
    },
    headerCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontWeight: 500, height: '44px', padding: '0', border: 'none' }
    },
    cellStyle() {
      return { color: '#1D2129', height: '48px', padding: '0', border: 'none' }
    },
    async fetchList() {
      this.loading = true
      try {
        const c = this.conditions
        const params = {
          page: this.pagination.page,
          row: this.pagination.row,
          workNo: c.workNo || undefined,
          location: c.location || undefined,
          alarmTypeCd: c.alarmType || undefined,
          handler: c.handler || undefined,
          startTime: c.startTime || undefined,
          endTime: c.endTime || undefined
        }
        // 超时工单用 timeoutFlag=Y，其他状态用 state
        if (c.state === 'TIMEOUT') {
          params.timeoutFlag = 'Y'
        } else if (c.state) {
          params.state = c.state
        }
        console.log('请求参数:', params) // 调试：查看发送的分页参数
        const res = await listInspectionWorks(params)
        console.log('工单列表返回数据:', res) // 调试：查看完整返回结果
        console.log('数据条数:', res.data ? res.data.length : 0, '总条数:', res.total)
        this.tableData = res.data
        this.pagination.total = res.total
      } catch (error) {
        this.$message.error(error.message || '获取列表失败')
      } finally {
        this.loading = false
      }
    },
    statusClass(state) {
      if (state === 'TIMEOUT') return 'status-wait'
      if (['1900', '2000'].includes(state)) return 'status-done'
      return 'status-other'
    },
    switchState(item) {
      this.conditions.state = item.statusCd
      this.pagination.page = 1
      this.fetchList()
    },
    handleView(row) {
      this.$router.push({ path: '/pages/inspection/workPoolDetail', query: { id: row.id } })
    },
    handleFinish(row) {
      this.$confirm(`确认将工单 "${row.workNo}" 办理完成吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          await completeInspectionWork({ id: row.id })
          this.$message.success('办理完成')
          this.fetchList()
        } catch (error) {
          this.$message.error(error.message || '操作失败')
        }
      }).catch(() => {})
    },
    handleClose(row) {
      this.$refs.endWorkOrder.open(row)
    },
    handleRefresh() {
      this.pagination.page = 1
      this.fetchList()
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    handleSizeChange(val) {
      this.pagination.row = val
      this.pagination.page = 1
      this.fetchList()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.fetchList()
    }
  }
}
</script>

<style scoped>
.wp-page { height: 100%; background: #F5F8FC; }
.wp-card { min-height: 100%; background: #FFFFFF; border-radius: 0 0 12px 12px; display: flex; flex-direction: column; overflow: hidden; }
.wp-header { padding: 20px 24px 12px; flex-shrink: 0; }
.wp-title { font: 600 16px/22px 'PingFang SC', sans-serif; color: #1D2129; }
.wp-divider { height: 1px; background: #DCE6F5; margin: 12px 0; }
.wp-toolbar { display: flex; align-items: center; gap: 16px; }
.wp-actions, .wp-search-group, .action-links, .wp-pagination, .sheet-tabs { display: flex; align-items: center; }
.sheet-filter-tabs { border-bottom: 1px solid #DCE6F5; }
.sheet-tabs { gap: 16px; min-height: 40px; align-items: center; }
.sheet-tabs .wp-btn-refresh { margin-left: 8px; margin-bottom: 14px; }
.sheet-tab { position: relative; border: none; background: transparent; color: #6A7282; font: 500 14px/20px 'PingFang SC', sans-serif; padding: 0 0 14px; cursor: pointer; }
.sheet-tab.is-active { color: #0E76FF; }
.sheet-tab.is-active::after { content: ''; position: absolute; left: 50%; bottom: -1px; width: 24px; height: 3px; border-radius: 3px; background: #0E76FF; transform: translateX(-50%); }
.wp-search-sheet { margin-top: 16px; }
.wp-search-group { gap: 12px; flex-wrap: wrap; justify-content: flex-start; }
.wp-btn-refresh { width: 36px; height: 36px; padding: 0; border-radius: 10px; border: 1px solid #DCE6F5; background: #FFFFFF; color: #6A7282; }
.wp-btn-refresh:hover { background: #F5F8FC; }
.wp-btn-search { height: 38px; padding: 0 16px; border-radius: 10px; border: 1px solid #0E76FF; background: #fff; color: #0E76FF; }
.wp-search-input.small, .wp-search-select, .wp-date { width: 150px; }
.wp-search-group >>> .el-input__inner { height: 38px; border-radius: 10px; border-color: #DCE6F5; color: #1D2129; }
.wp-date-range { display: flex; align-items: center; height: 38px; border: 1px solid #DCE6F5; border-radius: 10px; background: #fff; overflow: hidden; }
.wp-date-range .wp-date { width: 140px; }
.wp-date-range >>> .el-input__inner { border: none; border-radius: 0; }
.date-range-separator { width: 1px; height: 18px; background: #DCE6F5; }
.wp-table-section { flex: 1; padding: 12px 24px 0; overflow: auto; }
.wp-table-section >>> .el-table { border-radius: 8px; overflow: hidden; }
.wp-table-section >>> .el-table::before { display: none; }
.wp-table-section >>> .el-table th, .wp-table-section >>> .el-table td { border: none; }
.action-links { gap: 8px; white-space: nowrap; }
.action-link { color: #0E76FF; cursor: pointer; font-size: 14px; }
.action-link.danger { color: #F53F3F; }
.link-separator { width: 1px; height: 12px; background: #DCE6F5; }
.status-tag { display: inline-flex; align-items: center; justify-content: center; min-width: 58px; height: 24px; padding: 0 8px; border-radius: 6px; font-size: 13px; }
.status-wait { background: #FFF7E8; color: #D46B08; }
.status-done { background: #E8F7EF; color: #0E8A45; }
.status-other { background: #E8F3FF; color: #0E76FF; }
.wp-pagination { justify-content: flex-end; gap: 8px; padding: 16px 24px 24px; flex-shrink: 0; }
.pagination-total { color: #6A7282; font-size: 14px; }
.wp-pagination >>> .el-pagination { display: flex !important; }
.wp-pagination >>> .el-pagination__total { margin-right: 10px; }
.wp-pagination >>> .el-pagination__sizes { margin: 0 10px; }
.wp-pagination >>> .el-select .el-input__inner { height: 32px; border-radius: 8px; }
@media (max-width: 1280px) { .wp-toolbar { align-items: flex-start; flex-direction: column; } }
</style>
